import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {TeacherContext} from 'teacher/context'
import {formatNumber} from 'helpers/utils'
import Label from 'components/label'

import Icon from 'components/icon'

import Cover from 'components/Cover'
import './course.styl'

export default function Course(props) {
  const {id, name, lessonCount, inContract} = props
  const context = useContext(TeacherContext)
  const label = context.translate(`lesson${ lessonCount > 1 ? 's' : ''}_label`)
  return (
    <div className="course">
      <Link className="course-link"
        to={context.link({course: id}, context.match.path, {preserveQuery: true})}>
        <div className="cover">
          <Cover {...{course: id, courseName: name, width: 201, height: 260}} />
        </div>
        <div className="footer">
          <Label className="label" value={name} maxLength={20} />
          <div className="lesson-count">
            <div className="wrapper">
              <Icon name="lesson-count" />
              <label className="value">
                {formatNumber(lessonCount)}
              </label>
              <label className="label">{label}</label>
            </div>
          </div>
        </div>
      </Link>
      {!inContract && <div className="lock"><Icon name="lock" width={40} height={40} /></div>}
    </div>
  )
}

